// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "decco/src/Decco.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as App_Types_Date$DvmAdminFrontendFr from "../../common/types/App_Types_Date.bs.js";

var Fields = {
  brand: "brand",
  brandLabel: "brandLabel",
  startDate: "startDate",
  endDate: "endDate"
};

function row_encode(v) {
  return Js_dict.fromArray([
              [
                "brand",
                Decco.stringToJson(v.brand)
              ],
              [
                "brandLabel",
                Decco.optionToJson(Decco.stringToJson, v.brandLabel)
              ],
              [
                "startDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.startDate)
              ],
              [
                "endDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.endDate)
              ]
            ]);
}

function row_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var brand = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "brand"), null));
  if (brand.TAG === /* Ok */0) {
    var brandLabel = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "brandLabel"), null));
    if (brandLabel.TAG === /* Ok */0) {
      var startDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "startDate"), null));
      if (startDate.TAG === /* Ok */0) {
        var endDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "endDate"), null));
        if (endDate.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    brand: brand._0,
                    brandLabel: brandLabel._0,
                    startDate: startDate._0,
                    endDate: endDate._0
                  }
                };
        }
        var e = endDate._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".endDate" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = startDate._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".startDate" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = brandLabel._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".brandLabel" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = brand._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".brand" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function searchResult_encode(v) {
  return Js_dict.fromArray([
              [
                "content",
                Decco.listToJson(row_encode, v.content)
              ],
              [
                "total",
                Decco.intToJson(v.total)
              ]
            ]);
}

function searchResult_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var content = Decco.listFromJson(row_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "content"), null));
  if (content.TAG === /* Ok */0) {
    var total = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "total"), null));
    if (total.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                content: content._0,
                total: total._0
              }
            };
    }
    var e = total._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".total" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = content._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".content" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  Fields ,
  row_encode ,
  row_decode ,
  searchResult_encode ,
  searchResult_decode ,
}
/* App_Types_Date-DvmAdminFrontendFr Not a pure module */
